
/*
data-submittable

```html
<form submittable action="" method="">
</form>
```

Hijacks the submit event and submits the form via `fetch()`. Reads the form's
standard `enctype` attribute to set the mimetype of the request, but extends
it by permitting the value `"application/json"` as well as the standard
`"application/x-www-form-urlencoded"` and `"multipart/form-data"`.
*/

import compose from 'fn/compose.js';
import get     from 'fn/get.js';
import events  from 'dom/events.js';
import trigger from 'dom/trigger.js';
import { createOptions } from 'dom/request.js';
import { showMessage }   from '../../messages/module.js';


function toSelector(str) {
    return '[name="' + str + '"]';
}

function flattenErrors(object, form) {
    var errors = [];

    // Flatten errors into a list
    for (name in object) {
        errors.push.apply(errors,
            object[name].map(function(text) {
                return {
                    form: form,
                    name: name,
                    text: text
                };
            })
        );
    }

    return errors;
}

function setValidity(error) {
    var selector = toSelector(error.name);
    var input    = error.form.querySelector(selector);

    if (!input) {
        console.warn('Error given for non-existent field name="' + error.name + '"', error);
        return;
    }

    input.setCustomValidity(error.text);
}

events({ type: 'submit', select: '[data-submittable-swty]' }, document).each(function(e) {
    if (e.isDefaultPrevented) return;
    e.preventDefault();

    const form     = e.target;
    const method   = form.method;
    const url      = form.action || '';
    // Allow other values for enctype by reading the attribute first. The
    // enctype property is restricted to the three types accepted by browsers.
    const mimetype = form.getAttribute('enctype') || form.enctype;
    const formData = new FormData(form);
    const options  = Object.assign(createOptions(method, formData, mimetype), {
        redirect: 'manual'
    });

    const redirectUrl  = formData.get('next');

    fetch(url, options).then((response) => {
        if (response.ok) {
            window.location.href = redirectUrl || window.location.href;
            return;
        }

        response
        .json()
        .then((errors) => {
            // Format data and set custom validation messages on inputs
            flattenErrors(errors, form).forEach(setValidity);

            // Cause the validation handling found in data-validation.js to
            // pick up the custom validation messages and render them
            form.checkValidity();
        })
        .catch(showMessage);
    });
});
